var symphony = symphony || {};

;
(function () {

	symphony.stickyFooter = function () {

		$(document).ready(function () {
			var windowHeight = $('body').outerHeight();
			var pageHeight = $('#page').outerHeight();
			var difference = windowHeight - pageHeight;
			var paddingTop = $('body').css('padding-top');

			if (paddingTop && paddingTop.indexOf('px') > -1) {
				if (!isNaN(paddingTop.replace('px', ''))) {
					difference -= Number(paddingTop.replace('px', ''))
				}
			}

			if (difference > 0) {

				$('.globalFooter').css('bottom', -difference);
			}
		});



	};


})();
